<template>
  <div class="edit-rank-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" label-width="90px" :inline="true">
        <el-form-item label="排序:" prop>
          <el-input v-model.number="params.number" size="small" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="底色:" prop>
          <base-upload
            :cover="params.cover"
            :action="action"
            @successCallback="successCallback"
            :wSize="360"
            :hSize="480"
            :width="'180px'"
            :height="'240px'"
          ></base-upload>
        </el-form-item>
        <el-form-item label="类别:" prop>
          <el-select v-model="params.category" size="small" placeholder="请选择类别">
            <el-option :label="item.label" :value="item.value" v-for="(item,i) in active" :key="i"></el-option>
            <!-- <el-option label="限时活动" value="ios"></el-option> -->
          </el-select>
        </el-form-item>

        <el-form-item label="关联:" prop>
          <el-input v-model="params.related" size="small"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini">选择界面</el-button>
        </el-form-item>

        <el-form-item label="开始时间:" prop="startTime">
          <el-date-picker
            v-model="params.startTime"
            type="datetime"
            :editable="false"
            placeholder="请输入开始时间"
            size="small"
            @change="getTime1"
            :picker-options="pickerOptions1"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间:" prop="endTime">
          <el-date-picker
            v-model="params.endTime"
            type="datetime"
            :editable="false"
            placeholder="请输入结束时间"
            size="small"
            @change="getTime2"
            :picker-options="pickerOptions2"
          ></el-date-picker>
        </el-form-item>
        <br />
        <el-form-item label="状态:">
          <el-switch v-model="params.isActive"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { nowDate } from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
import API from "@/api";
export default {
  data() {
    return {
      id: "",
      flag: false,
      title: "",
      dialogVisible: false,
      // 时间段1选择范围
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      // 活动类别
      active: [
        {
          label: "永久活动",
          value: 1,
        },
        {
          label: "限时活动",
          value: 2,
        },
      ],
      // 时间段2选择范围
      pickerOptions2: {},
      params: {
        number: "",
        related: "",
        startTime: "",
        endTime: "",
        cover: "",
        category: "",
      },
      // 图片上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
    };
  },

  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "edit") {
            this.editRank();
          }
        } else {
          return false;
        }
      });
    },
    // 编辑精彩
    editRank() {
      let params = Object.assign({}, this.params, { id: this.id });
      API.updateRank(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("handlerRankList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        number: "",
        related: "",
        startTime: "",
        endTime: "",
        cover: "",
        category: "",
      };
    },
    // 开始时间 验证
    getTime1(times) {
      this.params.endTime = "";
      if (times.getTime() < new Date(nowDate()).getTime()) {
        this.$message.error("开始时间不能小于当前时间！");
        this.params.startTime = "";
      }
      this.pickerOptions2 = Object.assign({}, this.pickerOptions2, {
        disabledDate: (time) => {
          return time.getTime() < times - 8.64e7;
        },
      });
    },
    // 结束时间 验证
    getTime2(times) {
      if (times.getTime() <= new Date(this.params.startTime).getTime()) {
        this.$message.error("结束时间不能小于开始时间！");
        this.params.endTime = "";
      }
    },
    // eslint-disable-next-line no-unused-vars
    open(type, row) {
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑排行";
      }
    },
    // 榜单底色上传成功回掉
    successCallback(res) {
      this.params.cover = res.data.coverImg;
    },
  },
};
</script>
<style scoped>
.el-input {
  width: 180px;
}
</style>